import { annualReport } from './annual_report';
import { collections } from './collections';
import { composer } from './composer';
import { emojis } from './emojis';
import { profileEdit } from './profile_edit';

export const sliceReducers = {
  annualReport,
  collections,
  composer,
  emojis,
  profileEdit,
};
